"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoadingSpinnerWrapper = exports.StyledLoadingSpinner = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var componentName = _config["default"].componentName;
var sizeConfig = {
  xsmall: {
    height: 'var(--spacing-global-space5)',
    width: 'var(--spacing-global-space5)'
  },
  small: {
    height: 'var(--spacing-global-space6)',
    width: 'var(--spacing-global-space6)'
  },
  medium: {
    height: 'var(--spacing-global-space7)',
    width: 'var(--spacing-global-space7)'
  },
  large: {
    height: 'var(--spacing-global-space9)',
    width: 'var(--spacing-global-space9)'
  }
};
var responsiveCss = (0, _styledComponents.css)(["width:", ";height:", ";@media only screen and (min-width:", "){width:", ";height:", ";}@media only screen and (min-width:", "){width:", ";height:", ";}@media only screen and (min-width:", "){width:", ";height:", ";}"], sizeConfig.xsmall.width, sizeConfig.xsmall.height, _grid.gridConfig.s.minWidth, sizeConfig.small.width, sizeConfig.small.height, _grid.gridConfig.m.minWidth, sizeConfig.medium.width, sizeConfig.medium.height, _grid.gridConfig.l.minWidth, sizeConfig.large.width, sizeConfig.large.height);
var StyledLoadingSpinnerWrapper = exports.StyledLoadingSpinnerWrapper = _styledComponents["default"].div.attrs({
  className: "".concat(componentName)
}).withConfig({
  displayName: "styled-loading-spinner__StyledLoadingSpinnerWrapper",
  componentId: "sc-1vue09i-0"
})([""]);

// Data testid added via props to add in dynamic
var StyledLoadingSpinner = exports.StyledLoadingSpinner = _styledComponents["default"].div.attrs({
  className: "".concat(componentName, "__spinner"),
  'data-testid': "".concat(componentName, "__spinner")
}).withConfig({
  displayName: "styled-loading-spinner__StyledLoadingSpinner",
  componentId: "sc-1vue09i-1"
})(["", " svg{animation:fadein ", "s,rotate 1s linear infinite;> circle{stroke:", ";stroke-linecap:round;animation:dash 1.5s ease-in-out infinite;}}", " ", " ", ""], function (_ref) {
  var _sizeConfig, _sizeConfig2;
  var size = _ref.size;
  return size !== 'responsive' && (0, _styledComponents.css)(["width:", ";height:", ";"], sizeConfig === null || sizeConfig === void 0 || (_sizeConfig = sizeConfig["".concat(size)]) === null || _sizeConfig === void 0 ? void 0 : _sizeConfig.width, sizeConfig === null || sizeConfig === void 0 || (_sizeConfig2 = sizeConfig["".concat(size)]) === null || _sizeConfig2 === void 0 ? void 0 : _sizeConfig2.height) || responsiveCss;
}, function (_ref2) {
  var animationTime = _ref2.animationTime;
  return animationTime;
}, function (_ref3) {
  var colour = _ref3.colour;
  return colour;
}, (0, _styledComponents.css)(["@keyframes rotate{100%{transform:rotate(360deg);}}"]), (0, _styledComponents.css)(["@keyframes fadein{from{opacity:0;}to{opacity:1;}}"]), (0, _styledComponents.css)(["@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}}"]));